import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { porticoApi } from 'store/porticoApi'
import { stadiumApi } from 'store/stadiumApi'
import { reducer as appStateReducer } from 'store/appStateSlice'
import { errorHandlerMiddleware } from './middleware/errorHandler'

const persistConfig = {
  key: 'appState',
  version: 1,
  storage,
  blacklist: ['pagination'],
}

const persistedAppState = persistReducer(persistConfig, appStateReducer)

export const store = configureStore({
  reducer: {
    [porticoApi.reducerPath]: porticoApi.reducer,
    [stadiumApi.reducerPath]: stadiumApi.reducer,
    appState: persistedAppState,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(porticoApi.middleware, stadiumApi.middleware, errorHandlerMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})
